import { authSlice } from "./userAuth";
// import { thunk } from "redux-thunk";
// import themeReducer from './theme';
// import thunkMiddleware from "redux-thunk";
import { configureStore } from "@reduxjs/toolkit";
import { customerSlice } from "./customer";
import { settingsSlice } from "./settings";
import { rolesSlice } from "./role";
import { usersSlice } from "./users";
import { transactionSlice } from "./transaction";
import { dashboardSlice } from "./dashboard";
import { thirdPartySlice } from "./thirdParty";
import { notificationSlice } from "./notification";
import { notificationCampaignSlice } from "./notificationCampaign";
import { reportSlice } from "./report";
import { featureManagementSlice } from "./featureMgt";
import { exportSlice } from "./export";
import { ledgertSlice } from "./ledger";
import { referralSlice } from "./referral";
import { promotionSlice } from "./promotion";
import { influencerSlice } from "./influencer";
import { rateIntelligenceSlice } from "./rateIntelligence";

// create a makeStore function
const makeStore = () =>
  configureStore({
    reducer: {
      auth: authSlice.reducer,
      customer: customerSlice.reducer,
      settings: settingsSlice.reducer,
      roles: rolesSlice.reducer,
      users: usersSlice.reducer,
      transaction: transactionSlice.reducer,
      dashboard: dashboardSlice.reducer,
      thirdParty: thirdPartySlice.reducer,
      notification: notificationSlice.reducer,
      notification_campaign: notificationCampaignSlice.reducer,
      report: reportSlice.reducer,
      feature_mgt: featureManagementSlice.reducer,
      exports: exportSlice.reducer,
      ledger: ledgertSlice.reducer,
      referral: referralSlice.reducer,
      promotion: promotionSlice.reducer,
      influencer: influencerSlice.reducer,
      rate_intelligence: rateIntelligenceSlice.reducer,
      // theme: themeReducer, // Access the reducer generated by createSlice
    },
    // middleware: (getDefaultMiddleware: any) =>
    //   getDefaultMiddleware({
    //     serializableCheck: {
    //       ignoredActionPaths: [
    //         // 'payload.headers',
    //         // 'payload.config.transformRequest',
    //       ],
    //     },
    //   }).concat(thunk),
  });

const store = makeStore();

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
